module.exports = __webpack_public_path__ + "static/media/bai_btn2.1c247fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_btn2.png
// module id = 1468
// module chunks = 0